import Color from 'color';
export const cleanMark = (mark)=>{
    if (mark.type.name !== 'highlight') {
        return {};
    }
    if (mark.attrs['color']) {
        const col = Color(mark.attrs['color']).hex();
        return {
            color: col
        };
    }
    return {};
};

//# sourceMappingURL=highlight.js.map